import { render } from "./TijdelijkContactForm.vue?vue&type=template&id=0fef5478&scoped=true"
import script from "./TijdelijkContactForm.vue?vue&type=script&lang=js"
export * from "./TijdelijkContactForm.vue?vue&type=script&lang=js"

import "./TijdelijkContactForm.vue?vue&type=style&index=0&id=0fef5478&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fef5478"]])

export default __exports__